import { useEffect } from "react";
import { cursor } from "utils/customCursor";

export function useCustomCursor() {
  useEffect(() => {
    cursor();
  }, []);
}
